module.exports = {"admin":["view_monitoring","view_forecasting","view_scenario","add_scenario","delete_scenario"],"executor":["view_monitoring","view_forecasting","view_scenario","add_scenario","delete_scenario"],"viewer":["view_monitoring","view_forecasting"]}


//////////////////
// WEBPACK FOOTER
// ./src/acl.json
// module id = 744
// module chunks = 0